"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assert;

function assert(condition) {
  if (!condition) {
    throw new Error('viewport-mercator-project: assertion failed.');
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/viewport-mercator-project/dist/es5/assert.js
// module id = 191
// module chunks = 28901507966785 35783957827783